import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={102.611}
      height={71.297}
      viewBox="0 0 102.611 71.297"
      {...props}
    >
      <g data-name="Group 698">
        <path
          data-name="Path 2446"
          d="M23.818 49.042v20.3a1.566 1.566 0 01-1.562 1.562H1.952A1.566 1.566 0 01.39 69.342v-20.3a1.567 1.567 0 011.562-1.562h20.3a1.567 1.567 0 011.562 1.562zm-1.952 19.91V49.428H2.342v19.524z"
          fill="#003586"
        />
        <path
          data-name="Path 2447"
          d="M12.104 53.345a7.413 7.413 0 017.415 7.411h-1.167a6.248 6.248 0 10-12.495 0H4.693a7.42 7.42 0 017.411-7.411z"
          fill="#656d78"
        />
        <path
          data-name="Path 2448"
          d="M12.104 53.345a7.42 7.42 0 00-7.412 7.411h1.164a6.248 6.248 0 1112.495 0h1.167a7.412 7.412 0 00-7.415-7.411zm5.076 7.411a5.076 5.076 0 10-5.076 5.078 5.078 5.078 0 005.076-5.077zm4.685-11.327v19.523H2.342V49.429z"
          fill="#ccd1d9"
        />
        <path
          data-name="Path 2449"
          d="M12.104 56.848a.781.781 0 11-.781.781.781.781 0 01.781-.781z"
          fill="#ccd1d9"
        />
        <path
          data-name="Path 2450"
          d="M12.104 56.848a.781.781 0 10.781.781.783.783 0 00-.781-.781zm0-1.168a5.076 5.076 0 11-5.076 5.076 5.078 5.078 0 015.076-5.076z"
          fill="#ffd200"
        />
        <path
          data-name="Path 2451"
          d="M22.256 71.296H1.952a1.955 1.955 0 01-1.953-1.952V49.04a1.955 1.955 0 011.953-1.953h20.3a1.955 1.955 0 011.952 1.952v20.3a1.955 1.955 0 01-1.948 1.957zM1.952 47.869A1.173 1.173 0 00.781 49.04v20.3a1.173 1.173 0 001.171 1.171h20.3a1.173 1.173 0 001.171-1.171v-20.3a1.173 1.173 0 00-1.171-1.171z"
        />
        <path
          data-name="Path 2452"
          d="M21.866 69.34H2.342a.39.39 0 01-.39-.39V49.43a.39.39 0 01.39-.39h19.524a.39.39 0 01.39.39v19.524a.39.39 0 01-.39.386zm-19.133-.777h18.742V49.821H2.733z"
        />
        <path
          data-name="Path 2453"
          d="M12.104 66.222a5.467 5.467 0 115.467-5.467 5.473 5.473 0 01-5.467 5.467zm0-10.152a4.686 4.686 0 104.686 4.685 4.691 4.691 0 00-4.686-4.685z"
        />
        <path
          data-name="Path 2454"
          d="M12.104 58.8a1.171 1.171 0 111.171-1.171 1.173 1.173 0 01-1.171 1.171zm0-1.562a.39.39 0 10.39.39.391.391 0 00-.39-.39z"
        />
        <path
          data-name="Path 2455"
          d="M19.516 61.146a.39.39 0 01-.39-.39 7.022 7.022 0 00-14.044 0 .39.39 0 11-.781 0 7.803 7.803 0 0115.605 0 .39.39 0 01-.39.39z"
        />
        <path
          data-name="Path 2456"
          d="M18.351 61.146a.39.39 0 01-.39-.39 5.857 5.857 0 00-11.714 0 .39.39 0 11-.781 0 6.638 6.638 0 0113.276 0 .39.39 0 01-.391.39z"
        />
        <path
          data-name="Path 2457"
          d="M12.104 54.125a.39.39 0 01-.39-.39v-.4a.39.39 0 11.781 0v.4a.39.39 0 01-.391.39z"
        />
        <path
          data-name="Path 2458"
          d="M7.136 56.183a.389.389 0 01-.276-.114l-.281-.281a.39.39 0 01.552-.552l.281.281a.39.39 0 01-.276.667z"
        />
        <path
          data-name="Path 2459"
          d="M5.856 61.15H4.682a.39.39 0 010-.781h1.174a.39.39 0 010 .781z"
        />
        <path
          data-name="Path 2460"
          d="M19.526 61.15h-1.175a.39.39 0 010-.781h1.174a.39.39 0 010 .781z"
        />
        <path
          data-name="Path 2461"
          d="M17.071 56.183a.39.39 0 01-.276-.667l.281-.281a.39.39 0 11.552.552l-.281.281a.39.39 0 01-.276.115z"
        />
        <path
          data-name="Path 2462"
          d="M3.921 51.389a.39.39 0 010-.781.39.39 0 010 .781z"
        />
        <path
          data-name="Path 2463"
          d="M3.921 67.792a.39.39 0 010-.781.39.39 0 110 .781z"
        />
        <path
          data-name="Path 2464"
          d="M20.321 51.389a.39.39 0 010-.781.39.39 0 010 .781z"
        />
        <path
          data-name="Path 2465"
          d="M20.321 67.792a.39.39 0 010-.781.39.39 0 110 .781z"
        />
        <g data-name="008-lamp-7">
          <path
            data-name="Path 1827"
            d="M72.547 48.102a29.049 29.049 0 0026.887-18.038H45.66a29.048 29.048 0 0026.887 18.038zm0 0"
            fill="#ffd200"
          />
          <path
            data-name="Path 1828"
            d="M67.536 24.051H43.485v6.013h58.124v-6.013zm0 0"
            fill="#003586"
          />
          <path
            data-name="Path 1829"
            d="M43.485 24.051h58.124v2H43.485zm0 0"
            fill="#165a9f"
          />
          <g data-name="Group 160" fill="#231f20">
            <path
              data-name="Path 1830"
              d="M90.952 48.916a1.002 1.002 0 10-1.736 1l2.505 4.339a1.002 1.002 0 001.736-1zm0 0"
            />
            <path
              data-name="Path 1831"
              d="M47.037 43.134l-3.543 3.543a1.002 1.002 0 101.417 1.417l3.543-3.543a1.002 1.002 0 00-1.417-1.417zm0 0"
            />
            <path
              data-name="Path 1832"
              d="M72.545 53.114a1 1 0 00-1 1v5.011a1 1 0 002 0v-5.011a1 1 0 00-1-1zm0 0"
            />
            <path
              data-name="Path 1833"
              d="M63.728 51.957a1 1 0 00-1.227.709l-1.3 4.839a1.002 1.002 0 101.935.519l1.3-4.84a1 1 0 00-.708-1.227zm0 0"
            />
            <path
              data-name="Path 1834"
              d="M98.056 43.134a1.002 1.002 0 00-1.417 1.417l3.543 3.543a1.002 1.002 0 001.417-1.417zm0 0"
            />
            <path
              data-name="Path 1835"
              d="M55.51 48.548a1 1 0 00-1.369.368l-2.505 4.339a1.002 1.002 0 101.736 1l2.505-4.339a1 1 0 00-.367-1.37zm0 0"
            />
            <path
              data-name="Path 1836"
              d="M82.591 52.661a1.002 1.002 0 00-1.935.518l1.3 4.84a1.002 1.002 0 101.935-.519zm0 0"
            />
          </g>
          <path
            data-name="Path 1837"
            d="M78.56 1.002H66.534a6.013 6.013 0 1012.026 0zm0 0"
            fill="#003586"
          />
          <path
            data-name="Path 1838"
            d="M72.547 19.041a5.011 5.011 0 00-5.011 5.011h10.021a5.011 5.011 0 00-5.01-5.011zm0 0"
            fill="#165a9f"
          />
          <path
            data-name="Path 1839"
            d="M101.609 23.049H78.47a6.021 6.021 0 00-4.921-4.921V7.937A7.015 7.015 0 0079.562 1a1 1 0 00-1-1H66.535a1 1 0 00-1 1 7.015 7.015 0 006.013 6.935v10.193a6.021 6.021 0 00-4.921 4.921H43.484a1 1 0 00-1 1v6.013a1 1 0 001 1h1.531a30.031 30.031 0 0055.065 0h1.529a1 1 0 001-1v-6.011a1 1 0 00-1-1zM67.637 2h9.821a5.011 5.011 0 01-9.821 0zm4.91 18.038a4.017 4.017 0 013.882 3.006h-7.764a4.017 4.017 0 013.882-3.001zm0 27.058a27.932 27.932 0 01-25.353-16.03h50.707A27.933 27.933 0 0172.548 47.1zm28.06-18.038H44.484v-4.005h56.123zm0 0"
            fill="#231f20"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
